<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="workCenters"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @select="selectHandle"
      @reset="resetHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.printAuth" type="primary" :disabled="!selection.length" @click="printHandle">打印</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="中心编号">
            <el-input v-model.trim="filter.workCenterNo" placeholder="请输入生产中心编号" clearable />
          </el-form-item>
          <el-form-item label="中心名称">
            <el-input v-model.trim="filter.workCenterName" placeholder="请输入生产中心名称" clearable />
          </el-form-item>
          <el-form-item label="所属车间">
            <el-input v-model.trim="filter.workshopName" placeholder="请输入所属车间名称" clearable />
          </el-form-item>
          <el-form-item label="生产类型">
            <el-select v-model="filter.productionType" placeholder="请选择生产类型" clearable>
              <el-option label="单件完工" :value="0"></el-option>
              <el-option label="批量完工" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="载具绑定">
            <el-select v-model="filter.bindVehicleType" placeholder="请选择载具绑定类型" clearable>
              <el-option label="不绑定" :value="0"></el-option>
              <el-option label="需绑定验证" :value="1"></el-option>
              <el-option label="需绑不验证" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <WorkCenterEdit ref="workCenterEdit" @save-success="loadData"></WorkCenterEdit>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import WorkCenterEdit from "./WorkCenterEdit";
export default {
  components: { viewTable, WorkCenterEdit },
  data() {
    return {
      selection: [],
      limits: {
        addAuth: this.$auth(675),
        editAuth: this.$auth(676),
        delAuth: this.$auth(677),
        printAuth: this.$auth(678),
      },
      filter: {
        workCenterNo: "",
        workCenterName: "",
        workshopName: "",
        productionType: "",
        bindVehicleType: "",
      },
      columnsProperty: [
        {
          tooltip: true,
          key: "workCenterNo",
          width: 110,
          align: "center",
        },
        {
          tooltip: true,
          key: "workCenterName",
          minWidth: 150,
        },
        {
          tooltip: true,
          key: "productionTypeName",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "bindVehicleTypeName",
          width: 110,
          align: "center",
        },
        {
          tooltip: true,
          key: "isAutomaticDispatch",
          width: 90,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isAutomaticDispatch ? "是" : "否");
          },
        },
        {
          tooltip: true,
          key: "isLoadMaterial",
          width: 90,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isLoadMaterial ? "需要" : "不需要");
          },
        },
        {
          tooltip: true,
          key: "workshopName",
          minWidth: 150,
        },
        {
          tooltip: true,
          key: "warehouseName",
          minWidth: 150,
        },
        {
          tooltip: true,
          key: "creatorName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "createTime",
          width: 160,
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 140,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    // 查询生产中心列表
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 新增 编辑
    addEditHandle(row) {
      this.$refs.workCenterEdit.open(row);
    },

    // 删除
    deleteHandle(row) {
      this.$http.delete("basic", "workCenters", row.pkId).then((resp) => {
        if (resp.success) {
          this.loadData();
          this.$message.success("删除成功");
          this.selection = [];
        }
      });
    },

    selectHandle(selection) {
      this.selection = selection;
    },

    // 打印
    printHandle() {
      const routeUrl = this.$router.resolve({
        path: "/workCenterPrint",
        query: {
          params: JSON.stringify(this.selection),
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
